import React from "react";
import classnames from "classnames";
import ReactSwitch from "react-switch";
import { EyeIcon, HeartIcon, TrashIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Tooltip } from "@mui/material";
import { uuid } from "uuidv4";

import {
    store as generalSettingStore,
    setNumberMultiShopArchived,
    setNumberMultiShopActive,
    setIsValidateShopArchiveOpened,
    setIsLoading,
    setKey,
    setGlobalDataIsUpdated,
} from "../store";
import { store } from "@components/VerticalLayout/store";
import {
    setActivationDeactivationMessageModalOpened,
    setMessage,
    setYesFunction,
} from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";
import { generalConfigStore, setItemsDisable } from "@store";

import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";
import ErrorToast from "@components/Common/ErrorTost";
import {
    apiRequest,
    ArchivedLanguagesFranchise,
    createDataLanguage,
    createLanguageItem,
    isLanguageConsumed,
} from "../hooks";
import { ShowSuccessToast } from "../ShowSuccessToast";
import { useFetchGlobal } from "../../../../api/hooks";

type CustomIconsType = {
    e: any;
    isArchivedLanguagesClicked: boolean;
    shopState: any;
    setShopState: Function;
    modalState: any;
    setModalState: Function;
};

export function CustomIcons({
    e,
    isArchivedLanguagesClicked,
    shopState,
    setShopState,
    modalState,
    setModalState,
}: CustomIconsType) {
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const {
        numberMultiShopArchived,
        numberMultiShopActive,
        languagesData,
        modify,
        shopsLanguagesData,
        isLoading,
    } = useSnapshot(generalSettingStore);
    const { userID, franchiseID, operatorID } = useSnapshot(store);
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const [languageState, setLanguageState] = React.useState<boolean>(
        e.selectedRow.isActive
    );
    const uuidUser = localStorage.getItem("uuidUser");
    async function activeLanguage() {
        toast.dismiss();
        const id = e.selectedRow.Id;
        let dataLanguage = createDataLanguage(
            e.selectedRow,
            userID,
            franchiseID,
            operatorID,
            uuidUser,
            id,
            e.selectedRow.isActive,
            false,
            e.selectedRow.isFavorite
        );
        try {
            const result: any = await apiRequest(dataLanguage, fetchGlobal);
            if (result.error) {
                throw new Error("error");
            }
            if (
                e.selectedRow.isActive === false &&
                itemsDisable.find(
                    (item: any) =>
                        item.id === id && item.shopId === e.selectedRow.shopId
                ) === undefined
            ) {
                const item = [
                    ...JSON.parse(JSON.stringify(itemsDisable)),
                    {
                        id: id,
                        state: e.selectedRow.isActive,
                        shopId: e.selectedRow.shopId,
                    },
                ];
                setItemsDisable(item);
                localStorage.setItem("itemsDisable", JSON.stringify(item));
            }
            ShowSuccessToast(
                `${t("The language was successfully unarchived")}`
            );
            setKey(uuid());
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            ErrorToast(`${t("There's an error")}`);
        }
        setIsLoading(false);
    }

    async function favoriteLanguage(isFavorite: boolean) {
        if (isLoading === false) {
            setIsLoading(true);
            toast.dismiss();
            let shopLanguages: any = [];
            let objectData: any = {};
            let shopIds: any = [];
            shopsLanguagesData.forEach((element: any) => {
                if (element.shopId === e.selectedRow.shopId) {
                    shopLanguages = element.subRows;
                }
            });
            shopLanguages.forEach((language: any) => {
                let langueObject: any = JSON.parse(JSON.stringify(language));
                if (!shopIds.includes(langueObject.shopId.toString())) {
                    shopIds.push(langueObject.shopId.toString());
                    objectData[langueObject.shopId.toString()] = {};
                }
                if (langueObject.Id === e.selectedRow.Id) {
                    Object.assign(objectData[langueObject.shopId.toString()], {
                        ...createLanguageItem(
                            langueObject,
                            langueObject.Id,
                            true,
                            langueObject.isArchived,
                            true,
                            langueObject.shopId
                        ),
                    });
                } else if (langueObject.isFavorite === true) {
                    Object.assign(objectData[langueObject.shopId.toString()], {
                        ...createLanguageItem(
                            langueObject,
                            langueObject.Id,
                            langueObject.isActive,
                            langueObject.isArchived,
                            false,
                            langueObject.shopId
                        ),
                    });
                }
            });
            let dataLanguage = {
                userId: userID,
                shopId: [e.selectedRow.shopId],
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                data: objectData,
                isMultiShop: true,
                updateFavorite: true,
            };
            const updateFavorite = true;
            try {
                const result: any = await apiRequest(
                    dataLanguage,
                    fetchGlobal,
                    updateFavorite
                );
                if (result.error) {
                    throw new Error("error");
                }
                setGlobalDataIsUpdated!(true);
                ShowSuccessToast(
                    isFavorite
                        ? `${t("Favorite state has been enabled successfully")}`
                        : `${t(
                              "Favorite state has been disabled successfully"
                          )}`
                );
                setIsLoading(false);
            } catch (e) {
                ErrorToast(`${t("There's an error")}`);
                setIsLoading(false);
            }
        }
    }
    async function enableLanguage() {
        setIsLoading(true);
        toast.dismiss();
        const id = e.selectedRow.Id;
        let dataLanguage = createDataLanguage(
            e.selectedRow,
            userID,
            franchiseID,
            operatorID,
            uuidUser,
            id,
            !languageState,
            e.selectedRow.isArchived,
            e.selectedRow.isFavorite
        );
        const isStateChange = true;
        try {
            const result: any = await apiRequest(
                dataLanguage,
                fetchGlobal,
                isStateChange
            );
            if (result.error) {
                throw new Error("error");
            }
            setIsLoading(false);

            setGlobalDataIsUpdated!(true);
            ShowSuccessToast(
                languageState
                    ? `${t("The language was successfully deactivated")}`
                    : `${t("The language was successfully activated")}`
            );
            if (
                !languageState === false &&
                itemsDisable.find(
                    (item: any) =>
                        item.id === id && item.shopId === e.selectedRow.shopId
                ) === undefined
            ) {
                const item = [
                    ...JSON.parse(JSON.stringify(itemsDisable)),
                    {
                        id: id,
                        state: !languageState,
                        shopId: e.selectedRow.shopId,
                    },
                ];
                setItemsDisable(item);
                localStorage.setItem("itemsDisable", JSON.stringify(item));
            } else if (!languageState === true) {
                const item = itemsDisable.filter(
                    (item: any) =>
                        !(
                            item.id === id &&
                            item.shopId === e.selectedRow.shopId
                        )
                );
                setItemsDisable(item);
                localStorage.setItem("itemsDisable", JSON.stringify(item));
            }
        } catch (e) {
            setIsLoading(false);
            ErrorToast(`${t("There's an error")}`);
        }
    }
    let dataArchive = ArchivedLanguagesFranchise(languagesData);

    return (
        <React.Fragment>
            {e.selectedRow?.subRows === undefined ? (
                <div className="d-flex justify-content-around">
                    {modify === true ? (
                        <>
                            <Tooltip
                                title={
                                    isArchivedLanguagesClicked ||
                                    e.selectedRow.isFavorite === true
                                        ? ""
                                        : t("Enable favorite state")
                                }
                            >
                                <div>
                                    <HeartIcon
                                        onClick={() => {
                                            setIsLoading(true);
                                            if (
                                                e.selectedRow.isActive ===
                                                    false &&
                                                e.selectedRow.isFavorite ===
                                                    false
                                            ) {
                                                ErrorToast(
                                                    t(
                                                        "Please note, you cannot activate the favorite state for a disabled language"
                                                    )
                                                );
                                                setIsLoading(false);
                                            } else if (
                                                e.selectedRow.isFavorite ===
                                                false
                                            ) {
                                                setShopState({
                                                    ...shopState,
                                                    rowData: e.selectedRow,
                                                    shopId:
                                                        e.selectedRow.shopId,
                                                });
                                                favoriteLanguage(
                                                    !e.selectedRow.isFavorite
                                                );
                                                setIsLoading(false);
                                            }
                                        }}
                                        height={25}
                                        width={25}
                                        name="heart"
                                        fill={
                                            e.selectedRow.isFavorite
                                                ? "red"
                                                : "black"
                                        }
                                        className={`${classnames(
                                            "lan_icn_BTlike",
                                            {
                                                pointer__clz:
                                                    e.selectedRow.isFavorite ===
                                                    false,
                                            },
                                            {
                                                "not-allowed-icon__clz":
                                                    isArchivedLanguagesClicked ||
                                                    isLoading,
                                            }
                                        )}`}
                                    />
                                </div>
                            </Tooltip>
                            <>
                                <Tooltip
                                    title={
                                        isArchivedLanguagesClicked
                                            ? ""
                                            : languageState === false
                                            ? t("Activate")
                                            : t("Unactivate")
                                    }
                                >
                                    <div>
                                        <ReactSwitch
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            handleDiameter={26}
                                            offColor="#f7b4b8"
                                            offHandleColor="#E30613"
                                            checked={languageState}
                                            onChange={async () => {
                                                setIsLoading(true);
                                                if (
                                                    e.selectedRow.isFavorite ===
                                                    true
                                                ) {
                                                    ErrorToast(
                                                        t(
                                                            "Please note, you cannot deactivate a favorite language"
                                                        )
                                                    );
                                                    setIsLoading(false);
                                                } else {
                                                    setMessage(
                                                        languageState
                                                            ? t(
                                                                  "Caution, the language may be used by other modules.\n Would you like to confirm the deactivation of the selected language?"
                                                              )
                                                            : t(
                                                                  "Would you like to confirm the activation of the selected language?"
                                                              )
                                                    );
                                                    setYesFunction(() => {
                                                        setLanguageState(
                                                            !languageState
                                                        );
                                                        enableLanguage();
                                                    });

                                                    setActivationDeactivationMessageModalOpened(
                                                        true
                                                    );
                                                    setIsLoading(false);
                                                }
                                            }}
                                            onColor="#c2eddd"
                                            onHandleColor="#34C38F"
                                            width={50}
                                            height={20}
                                            className={`${classnames(
                                                "pointer__clz cmn_icn_BTenableDisable ml-3",
                                                {
                                                    "not-allowed-icon__clz":
                                                        isArchivedLanguagesClicked ||
                                                        isLoading,
                                                }
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>

                                {!isArchivedLanguagesClicked ? (
                                    <Tooltip title={t("Archive")}>
                                        <div>
                                            <TrashIcon
                                                onClick={async () => {
                                                    if (isLoading === false) {
                                                        setIsLoading(true);
                                                        if (
                                                            e.selectedRow
                                                                .isFavorite ===
                                                            true
                                                        ) {
                                                            ErrorToast(
                                                                t(
                                                                    "Please note, you cannot archive a favorite language"
                                                                )
                                                            );
                                                            setIsLoading(false);
                                                        } else {
                                                            let isConsumed = await isLanguageConsumed(
                                                                e,
                                                                t,
                                                                franchiseID,
                                                                fetchGlobal
                                                            );
                                                            if (
                                                                isConsumed ===
                                                                true
                                                            ) {
                                                                ErrorToast(
                                                                    t(
                                                                        "Please note, you cannot archive an element used in a template"
                                                                    )
                                                                );
                                                                setIsLoading(
                                                                    false
                                                                );
                                                            } else {
                                                                setShopState({
                                                                    ...shopState,
                                                                    selectedRows: [
                                                                        e.selectedRow,
                                                                    ],
                                                                });
                                                                setIsLoading(
                                                                    false
                                                                );
                                                                setIsValidateShopArchiveOpened(
                                                                    true
                                                                );
                                                            }
                                                        }
                                                    }
                                                }}
                                                height={25}
                                                width={25}
                                                fill="red"
                                                style={{
                                                    cursor: "pointer",
                                                }}
                                                className={`${classnames(
                                                    "cmn_icn_BTarchived ml-3",
                                                    {
                                                        "not-allowed-icon__clz": isLoading,
                                                    }
                                                )}`}
                                            />
                                        </div>
                                    </Tooltip>
                                ) : (
                                    <Tooltip
                                        title={
                                            dataArchive.includes(
                                                e.selectedRow.Id
                                            )
                                                ? ""
                                                : t("Unarchive")
                                        }
                                    >
                                        <div>
                                            <EyeIcon
                                                height={25}
                                                width={25}
                                                onClick={() => {
                                                    setIsLoading(true);
                                                    activeLanguage();
                                                    setNumberMultiShopArchived(
                                                        numberMultiShopArchived -
                                                            1
                                                    );
                                                    setNumberMultiShopActive(
                                                        numberMultiShopActive +
                                                            1
                                                    );
                                                }}
                                                style={{
                                                    cursor: "pointer",
                                                }}
                                                className={classnames(
                                                    "pointer__clz cmn_icn_BTunarchive ml-3",
                                                    {
                                                        "not-allowed-icon__clz":
                                                            isLoading ||
                                                            dataArchive.includes(
                                                                e.selectedRow.Id
                                                            ),
                                                    }
                                                )}
                                            />
                                        </div>
                                    </Tooltip>
                                )}
                            </>
                        </>
                    ) : null}
                    <Tooltip title={t("Consult history")}>
                        <div>
                            <TimePastSvgIcon
                                style={{ cursor: "pointer" }}
                                className={classnames(
                                    "pointer__clz cmn_icn_BThistory ml-3",
                                    {
                                        "not-allowed-icon__clz": isLoading,
                                    }
                                )}
                                onClick={() => {
                                    setShopState({
                                        ...shopState,
                                        rowData: e.selectedRow,
                                        selectedRows: [e.selectedRow],
                                    });
                                    setModalState({
                                        ...modalState,
                                        isHistoryModalOpened: !modalState.isHistoryModalOpened,
                                    });
                                }}
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : null}
        </React.Fragment>
    );
}
